module.exports = {
    id: {
        itemUpdatePropertyName: 'style'
    },
    name: {},
    basedOn: {},
    kind: {}
};
